import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Package, LockKey, User } from "@phosphor-icons/react";

const IMG =
  "https://images.unsplash.com/photo-1605732562084-f528a2154616?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNvbnRhaW5lcnMlMjBkYXJrJTIwbmlnaHR8ZW58MHx8fHwxNzg0MjE3OTk2fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setBusy(true);
    const r = await login(username.trim(), password);
    setBusy(false);
    if (r.ok) {
      toast.success("Ingreso exitoso");
      nav("/dashboard");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="grid md:grid-cols-2 bg-[#050505] text-white" style={{ minHeight: "100dvh" }}>
      {/* Left: form */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md fade-up">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-11 h-11 rounded-sm bg-[#0055FF] flex items-center justify-center">
              <Package size={22} weight="fill" color="#fff" />
            </div>
            <div>
              <div className="font-display text-xl leading-none">WAREHOUSE RCN</div>
              <div className="font-mono-data text-[10px] tracking-widest text-white/50 mt-1">
                CONTROL · DE · CITAS
              </div>
            </div>
          </div>

          <h1 className="font-display text-4xl sm:text-5xl mb-2">Bienvenido.</h1>
          <p className="text-white/60 mb-8 text-sm">
            Ingresa con tu usuario para acceder al panel operativo.
          </p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-[11px] font-mono-data uppercase tracking-widest text-white/50 mb-2">
                Usuario
              </label>
              <div className="relative">
                <User
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40"
                />
                <input
                  data-testid="login-username-input"
                  autoFocus
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full pl-10 pr-3 py-3 rounded-sm bg-[#111111] border border-white/10 text-sm text-white placeholder:text-white/30 focus:border-[#0055FF] focus:ring-1 focus:ring-[#0055FF] transition-colors outline-none"
                  placeholder="admin"
                />
              </div>
            </div>
            <div>
              <label className="block text-[11px] font-mono-data uppercase tracking-widest text-white/50 mb-2">
                Contraseña
              </label>
              <div className="relative">
                <LockKey
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40"
                />
                <input
                  data-testid="login-password-input"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-3 py-3 rounded-sm bg-[#111111] border border-white/10 text-sm text-white placeholder:text-white/30 focus:border-[#0055FF] focus:ring-1 focus:ring-[#0055FF] transition-colors outline-none"
                  placeholder="••••••••"
                />
              </div>
            </div>
            <button
              data-testid="login-submit-button"
              disabled={busy}
              className="w-full py-3 rounded-sm bg-[#0055FF] text-white font-semibold text-sm hover:brightness-110 active:scale-[0.98] transition-transform disabled:opacity-50"
            >
              {busy ? "Ingresando…" : "Ingresar"}
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-white/50">
            ¿No tienes cuenta?{" "}
            <Link
              to="/register"
              data-testid="go-to-register"
              className="text-[#0055FF] hover:brightness-125"
            >
              Regístrate
            </Link>
          </div>

          <div className="mt-10 pt-6 border-t border-white/10 text-[11px] font-mono-data text-white/40 tracking-wider">
            v1.0 · WAREHOUSE MANAGEMENT SYSTEM
          </div>
        </div>
      </div>

      {/* Right: image */}
      <div className="hidden md:block relative">
        <img
          src={IMG}
          alt="Contenedores"
          className="absolute inset-0 w-full h-full object-cover opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#050505]/60" />
        <div className="absolute bottom-10 left-10 right-10">
          <div className="font-mono-data text-[10px] uppercase tracking-[0.3em] text-[#0055FF] mb-2">
            OPERACIONES · NACIONAL
          </div>
          <div className="font-display text-3xl leading-tight max-w-md">
            Control total desde la recepción hasta el cierre.
          </div>
        </div>
      </div>
    </div>
  );
}
